import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RequestService } from '../../services/request/request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agent-accesses-modal',
  templateUrl: './agent-accesses-modal.component.html',
  styleUrls: ['./agent-accesses-modal.component.scss'],
})
export class AgentAccessesModalComponent implements OnInit, OnDestroy {

  @Input() profile_id: any;

  pendingRequests: any[] = [];
  activeAgents: any[] = [];
  loading = true;

  private destroyed = false;

  constructor(
    private modalController: ModalController,
    private requestService: RequestService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const pendingRes: any = await this.requestService.createRequestGet('agent-access-requests', { status: 'pending' });
      console.log('[AgentAccess] raw pendingRes:', pendingRes);
      this.pendingRequests = this.normalizeToArray(pendingRes);
      console.log('[AgentAccess] normalized pendingRequests:', this.pendingRequests);

      const activeRes: any = await this.requestService.createRequestGet('get_my_authenticated_mcps');
      this.activeAgents = this.normalizeToArray(activeRes);
    } catch (err) {
      console.error('Error loading agent accesses', err);
    }

    this.loading = false;

    if (!this.destroyed) {
      // Use setTimeout so the view has time to settle inside the Ionic modal
      setTimeout(() => this.cdr.detectChanges(), 0);
    }
  }

  private normalizeToArray(res: any): any[] {
    if (!res) return [];

    let data = res;

    if (typeof res === 'string') {
      let str = res.trim();

      // Handle common Laravel debug leftovers like "dd [...]" or "array:1 [...]" etc.
      // Try to extract the first JSON array or object from the string
      const jsonStart = str.search(/[\{\[]/);
      if (jsonStart > 0) {
        str = str.substring(jsonStart);
      }

      if (str.startsWith('{') || str.startsWith('[')) {
        try {
          data = JSON.parse(str);
        } catch {
          // Last resort: try to find a JSON array anywhere in the string
          const arrayMatch = str.match(/\[.*\]/s);
          if (arrayMatch) {
            try { data = JSON.parse(arrayMatch[0]); } catch { data = []; }
          } else {
            return [];
          }
        }
      } else {
        return [];
      }
    }

    if (Array.isArray(data)) return data;
    if (data?.data && Array.isArray(data.data)) return data.data;
    if (data?.results && Array.isArray(data.results)) return data.results;

    // Single object fallback
    if (data && typeof data === 'object' && (data.id != null)) return [data];

    return [];
  }

  async approveRequest(requestId: number) {
    try {
      // Use the proper service pattern (base + params + secondEndPoint) instead of building the full path string.
      // This prevents selectEnpoint() from returning null, which was causing the crash in createHeaders.
      await this.requestService.createRequestPost('agent-access-requests', {}, { id: requestId }, 'approve', {});
      this.loadData();
    } catch (e) {
      console.error(e);
    }
  }

  async denyRequest(requestId: number) {
    try {
      await this.requestService.createRequestPost('agent-access-requests', {}, { id: requestId }, 'deny', {});
      this.loadData();
    } catch (e) {
      console.error(e);
    }
  }

  async revokeAgent(agent: any) {
    const result = await Swal.fire({
      title: '¿Revocar acceso?',
      html: `
        <p>Estás a punto de revocar el acceso a <strong>${agent.client_name}</strong>.</p>
        <p>Este agente ya no podrá crear publicaciones en tu nombre.</p>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, revocar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) return;

    try {
      await this.requestService.createRequestDelete('authorized-agents', null, { id: agent.id });
      Swal.fire('Revocado', 'El agente ya no tiene acceso.', 'success');
      this.loadData();
    } catch (e) {
      console.error(e);
      Swal.fire('Error', 'No se pudo revocar el acceso.', 'error');
    }
  }

  dismiss() {
    this.modalController.dismiss();
  }

  ngOnDestroy() {
    this.destroyed = true;
  }
}
